module.exports = __webpack_public_path__ + "static/media/c2.aa1cf6d7.jpg";